import React, { useEffect, useState } from 'react';
import moment from 'moment';
import { Row, Col, DatePicker, Form, Input, Select, Button, message } from 'antd';
import { IoIosArrowForward } from 'react-icons/io';
import { AiOutlineSave } from 'react-icons/ai';
import { Config } from '../../../Config';
import { useGlobalState } from '../../../store/state';
import { validatorPINCODE } from '../../../utils';
import { GetCountryDetails } from '../../../apis/Influencer/Profile/GetCountryDetails';

const { Item, useForm } = Form;
const { Option } = Select;
const { TextArea } = Input;
const ProfileUserBasicsComponent = ({ setCurrentTab, updateProfile, genderList, cityList, refreshProfile, dob, languages }) => {
  const [user] = useGlobalState('user');
  const [profileBasicForm] = useForm();
  const [stateList, setStateList] = useState([]);


  // get state List


  useEffect(()=>{
    // setTimeout(() =>{
    // console.log("get it")
    // refreshProfile()
    // },[1000])
    // GetCountryDetails()
    GetCountryDetails().then((res) =>{
      // console.log("res",res[Config.country])
      setStateList(res[Config.country].states);
    });
  }, []);
  function dobPickLimit (current) {
    // Min age need to be 18
    if (current) {
      return current && current > moment().subtract(18, 'years');
    }
  }
  // @note: save basic profile details
  const saveBasicProfile = (formData) => {
    let _data = {};
    for (const [key, value] of Object.entries(formData)) {
      if (value) {
        _data[key] = value;
      }
      if (key === 'city' || key === 'line1' || key === 'line2' || key === 'pin' || key === 'state' || key === 'country') {
        _data = {
          ..._data,
          address: {
            ..._data.address,
            [key]: value,
          },
        };
        delete _data.line1;
        delete _data.line2;
        delete _data.city;
        delete _data.pin;
        delete _data.state;
        delete _data.country;
      }
    }
    if (formData.dateOfBirth) {
      _data.dateOfBirth = moment.utc(formData.dateOfBirth.toISOString())._i;
    }
    console.log('data to update', _data);

    // note: pass data to update in parent component
    updateProfile(_data);
  };
  return (
    <div className="prof_widget_basics pr-md-1">
      <Form
        form={profileBasicForm}
        name="profileBasicForm"
        layout="vertical"
        requiredMark={false}
        onFinish={saveBasicProfile}
        // initialValues={{
        //     dateOfBirth:moment(user?.date_of_birth)
        // }}
      >
        <div className="row">
          <div className="col-md-6 align-self-center">
            <Row gutter={15}
              align="top">
              <Col>
                <div className="prof_widget_basics--avatar">
                  <img src={user?.profilepicture}
                    className="img-fluid"
                    alt={user?.firstname} />
                </div>
              </Col>
              <Col>
                <h4 className="prof_widget_basics--title mb-0">Hello <span>{user?.firstname} {user?.lastname}</span></h4>
                <p className="mb-0">We can't wait to know you more</p>
              </Col>
            </Row>
          </div>
          <div className="col-md-6">
            <Item
              label="Bio"
              name="shortinfo"
              initialValue={user?.shortinfo}
            >
              <TextArea rows={4}
                className="common_input"
                placeholder="Write something about you."/>
            </Item>
          </div>

          <div className="col-md-3">
            <Item
              label="First Name"
              name="firstname"
              initialValue={user?.firstname}
              rules={[{ required: true, message: 'first name can\'t be empty' }]}
            >
              <Input type="text"
                size="large"
                className="common_input"
                placeholder="your first name"/>
            </Item>
          </div>
          <div className="col-md-3">
            <Item
              label="Last Name"
              name="lastname"
              initialValue={user?.lastname}
              rules={[{ required: true, message: 'last name can\'t be empty' }]}
            >
              <Input type="text"
                size="large"
                className="common_input"
                placeholder="your last name"/>
            </Item>
          </div>
          <div className="col-md-3">
            <Item
              label="Email ID"
            >
              <Input type="email"
                defaultValue={user?.email}
                size="large"
                disabled
                className="common_input"
                placeholder="your Email ID"/>
            </Item>
          </div>
          <div className="col-md-3">
            <Item
              label="Phone number"
            >
              <Input defaultValue={user?.phone}
                type="number"
                size="large"
                disabled
                className="common_input"
                placeholder="your Phone Number"/>
            </Item>
          </div>

          <div className="col-md-3">
            <Item
              label="Date of Birth"
              // label={`${moment(user?.date_of_birth).utc().utcOffset('+0530').format('DD/MM/YYYY')}`}
              name="dateOfBirth"
              initialValue={user?.date_of_birth ? moment(user?.date_of_birth) : undefined}
              // initialValue={moment(user?.date_of_birth) || undefined}
            >
              <DatePicker size="large"
                className="common_input"
                style={{ width: '100%' }}
                format={'Do MMM YYYY'}
                disabledDate={dobPickLimit}
                defaultPickerValue={moment().subtract(18, 'years')}
                placeholder="Date of birth"/>
            </Item>
          </div>
          <div className="col-md-3">
            <Item
              label="Gender"
              name="gender"
              initialValue={user?.gender || undefined}
            >
              <Select size="large"
                className="common_select"
                placeholder="Select your Gender">
                {
                  genderList.map((gender) => (
                    <Option key={gender}
                      value={gender}>{gender}</Option>
                  ))
                }
              </Select>
            </Item>
          </div>
          <div className="col-md-3">
            <Item
              label="Languages"
              name="languages"
              initialValue={user?.languages || undefined}
            >
              {/* <Input type="text" size="large" className="common_input" placeholder="Eg: English"/> */}
              <Select size="large"
                className="common_select"
                placeholder="Languages Known"
                mode="tags"
                maxTagCount='responsive'>
                {
                  languages.map((lang) => {
                    if (lang.length) {
                      return <Option key={lang}
                        value={lang}>{lang}</Option>;
                    }
                  })
                }
              </Select>
            </Item>
          </div>
          <div className="col-md-3">
            <Item
              label="Country"
              name="country"
              initialValue={Config.country || undefined}
            >

              <Select defaultValue={Config.country || user?.address.country}
                size="large"
                disabled
                className="common_select"
                placeholder="Select your Country">
                <Option value={Config.country}>{Config.country}</Option>
              </Select>
            </Item>
          </div>


          <div className="col-md-3">
            <Item
              label="Address line 1"
              name="line1"
              initialValue={user?.address?.line2 || undefined}
            >
              <Input type="text"
                size="large"
                className="common_input"
                placeholder="Flat No. 123 cross road"/>
            </Item>
          </div>
          <div className="col-md-3">
            <Item
              label="Address line 2"
              name="line2"
              initialValue={user?.address?.line2 || undefined}
            >
              <Input type="text"
                size="large"
                className="common_input"
                placeholder="Street, city, country"/>
            </Item>
          </div>
          <div className="col-md-3">
            <Item
              label="city"
              name="city"
              initialValue={user?.address?.city || undefined}
            >
              <Select size="large"
                className="common_select"
                placeholder="Select your City">
                {
                  cityList.map((city) => {
                    return city === ('All '+Config.country) ? null :<Option key={city}
                      value={city}>{city}</Option>;
                  })
                }
              </Select>
            </Item>
          </div>
          <div className="col-md-3">
            {/* <Item
                            label="State"
                            name="state"
                            initialValue={user?.address?.state || undefined}
                        >
                            <Select size="large" className="common_select" placeholder="Select your City">
                                <Option value="Karnataka">Karnataka</Option>
                            </Select>
                        </Item>  */}
            <Item
              label="State"
              name="state"
              initialValue={user?.address?.state || undefined}
              rules={[
                { required: true, message: 'This field can\'t be empty' },
              ]}
            >
              <Select size="large"
                showSearch
                placeholder="Select your state"
                className="common_select">
                {
                  stateList.map(({ code, name })=>(
                    <Option key={code}
                      value={name}>{name} [{code}]</Option>
                  ))
                }
              </Select>
            </Item>
          </div>
          <div className="col-md-3">
            <Item
              label="Pin Code"
              name="pin"
              initialValue={user?.address?.pin}
              rules={[
                {
                  validator: (_, value)=>{
                    if (value && !validatorPINCODE(value)) {
                      return Promise.reject(new Error('Invalid Pincode'));
                    } else {
                      return Promise.resolve();
                    }
                  },
                },
              ]}
            >
              <Input type="number"
                size="large"
                className="common_input"
                placeholder="Pincode"/>
            </Item>
          </div>
          <div className="col-md-9 text-right pt-3 mt-1">
            <span>
              <Button htmlType="submit"
                className="common_button">Save</Button>
            </span>
            <span className="ml-3">
              <Button className="common_button outlined"
                onClick={() => setCurrentTab('1')}>Platforms <IoIosArrowForward className="ml-2"/></Button>
            </span>
          </div>
        </div>
      </Form>
    </div>
  );
};

export default ProfileUserBasicsComponent;
